import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/informe-tecnico-final';

export const getProyectosInformeTecnicoFinal = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/proyectos`);
    return { status: response.status, data: response.data || [] };
  } catch (error) {
    console.error('Error al obtener proyectos (Informe Técnico Final):', error);
    return { status: 500, data: [] };
  }
};

export const getDriveFolder = async (codigo, folderId) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/${codigo}/drive`, {
      params: folderId ? { folderId } : {},
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    console.error('Error al consultar carpeta de Drive:', error);
    return {
      status: error.response?.status || 500,
      data: null,
      message: error.response?.data?.message || 'No se pudo consultar la carpeta de Drive'
    };
  }
};

export const descargarInformeTecnicoFinal = async (codigo, onDownloadProgress) => {
  const response = await axios.get(`${baseUrl}${endpoint}/${codigo}/descargar`, {
    responseType: 'blob',
    onDownloadProgress,
  });
  return response.data;
};

export const obtenerEstadoZipCache = async (codigo) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/${codigo}/zip-cache`);
    return { status: response.status, data: response.data };
  } catch (error) {
    console.error('Error al consultar el estado del paquete de descarga:', error);
    return { status: 500, data: null };
  }
};

export const generarZipCache = async (codigo) => {
  const response = await axios.post(`${baseUrl}${endpoint}/${codigo}/zip-cache/generar`);
  return { status: response.status, data: response.data };
};

export const cancelarZipCache = async (codigo) => {
  const response = await axios.post(`${baseUrl}${endpoint}/${codigo}/zip-cache/cancelar`);
  return { status: response.status, data: response.data };
};

export const setDriveFolderConfig = async (codigo, driveFolderId) => {
  const response = await axios.put(`${baseUrl}${endpoint}/${codigo}/drive/config`, {
    driveFolderId,
  });
  return { status: response.status, data: response.data };
};

export const subirArchivos = async (codigo, parentFolderId, files, paths, onUploadProgress, signal) => {
  const formData = new FormData();
  formData.append('parentFolderId', parentFolderId);
  files.forEach((file, i) => {
    formData.append('files', file);
    formData.append('paths', paths?.[i] || file.name);
  });

  const response = await axios.post(`${baseUrl}${endpoint}/${codigo}/drive/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
    signal,
  });
  return { status: response.status, data: response.data };
};

export const actualizarArchivoContenido = async (codigo, fileId, file, path) => {
  const formData = new FormData();
  formData.append('file', file);
  if (path) formData.append('path', path);

  const response = await axios.put(
    `${baseUrl}${endpoint}/${codigo}/drive/archivo/${fileId}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return { status: response.status, data: response.data };
};

export const renombrarItem = async (codigo, { fileId, nuevoNombre, tipo, path, nombreAnterior }) => {
  const response = await axios.patch(`${baseUrl}${endpoint}/${codigo}/drive/renombrar`, {
    fileId,
    nuevoNombre,
    tipo,
    path,
    nombreAnterior,
  });
  return { status: response.status, data: response.data };
};

export const crearCarpeta = async (codigo, parentFolderId, nombre, path) => {
  const response = await axios.post(`${baseUrl}${endpoint}/${codigo}/drive/carpeta`, {
    parentFolderId,
    nombre,
    path,
  });
  return { status: response.status, data: response.data };
};

export const eliminarItem = async (codigo, { fileId, tipo, nombre, path }, signal) => {
  const response = await axios.delete(`${baseUrl}${endpoint}/${codigo}/drive/${fileId}`, {
    data: { tipo, nombre, path },
    signal,
  });
  return { status: response.status, data: response.data };
};

export const obtenerEspacioDrive = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/drive/espacio`);
    return { status: response.status, data: response.data };
  } catch (error) {
    console.error('Error al consultar el espacio de Drive:', error);
    return { status: error.response?.status || 500, data: null };
  }
};

export const getHistorialProyecto = async (codigo) => {
  const response = await axios.get(`${baseUrl}${endpoint}/${codigo}/historial`);
  return { status: response.status, data: response.data || [] };
};
